module.exports = __webpack_public_path__ + "img/keitaro-landing-step-1.ru.66f96ab4.jpg";